import React from 'react';
import * as Ons from 'react-onsenui';
import Game from '../containers/Pages/Game';
import GameReportReferee from '../containers/Pages/GameReportReferee';
import Games from '../containers/Pages/Games';
import Rosters from '../containers/Pages/Rosters';
import Seasons from '../containers/Pages/Seasons';
class Navigator extends React.Component {

    #navigator;

    constructor( props ) {

        super( props );

        this.handleRenderPage = this.handleRenderPage.bind( this );
        this.handleChangePage = this.handleChangePage.bind( this );

    }

    componentDidUpdate() {

        // console.log( 'components.Navigator.componentDidUpdate()', this.props );

        this.handleChangePage( this.props.route );

    }

    handleRenderPage( route, navigator ) {

        // console.log( 'components.Navigator.handleRenderPage()', route, navigator );

        this.#navigator = navigator;

        switch ( route.page ) {

            case 'game':

                return <Game key="game" onMenuClick={this.props.onMenuClick} />;

            case 'gameReportReferee':

                return <GameReportReferee key="gameReportReferee" onMenuClick={this.props.onMenuClick} />;

            case 'games':

                return <Games key="games" onMenuClick={this.props.onMenuClick} />;

            case 'rosters':

                return <Rosters key="rosters" onMenuClick={this.props.onMenuClick} />;

            default:

                return <Seasons key="seasons" onMenuClick={this.props.onMenuClick} />;

        }

    }

    handleChangePage( route ) {

        // console.log( 'components.Navigator.handleChangePage()', this.#navigator );

        this.#navigator.resetPage( route );

    }

    render() {

        return (

            <Ons.Navigator renderPage={this.handleRenderPage} initialRoute={this.props.route} swipeable animation="fade" />

        );

    };

}

export default Navigator;